import ua from './ua'
import ru from './ru'
import de from './de'
import en from './en'

export default {
  ua,
  ru,
  de,
  en,
}
